import {
  AboveGradeWallType,
  BelowGradeWallType,
  EdgeItemType
} from 'data/types';

type WallWithOpeningsType = AboveGradeWallType | BelowGradeWallType;

export function edgeItemsFromWall(wall: WallWithOpeningsType): EdgeItemType[] {
  const items: EdgeItemType[] = [];

  wall.verticalGlass?.forEach((glass) => {
    const isGlassDoor =
      glass.fenestrationType === 'Sliding Glass Door' ||
      glass.fenestrationType === 'French Door';
    items.push({
      type: isGlassDoor ? 'glass-door' : 'window',
      id: glass.uniqueId,
      width: glass.width,
      height: glass.height,
      valid: glass.valid,
      positionOnWall: glass.positionOnWall,
      ...(isGlassDoor
        ? {
            glassPaneCount: glass.fenestrationType === 'French Door' ? 2 : 1
          }
        : {})
    });
  });

  if ('solidDoors' in wall) {
    wall.solidDoors?.forEach((door) => {
      items.push({
        type: 'door',
        id: door.uniqueId,
        width: door.width,
        height: door.height,
        material: door.material,
        valid: door.valid,
        positionOnWall: door.positionOnWall
      });
    });
  }

  return items;
}
